customElements.define('wish-list', class Wishlist extends HTMLElement {
  constructor() {
    super();

    this.containers = [
      this.querySelector('.grid')
    ];

    this.productHtml = [];
    this.wishlist = localStorage.getItem(Woolman.Wishlist.settings.storageKey) ? localStorage.getItem(Woolman.Wishlist.settings.storageKey).split(',') : [];

    this.init();
  }

  async init() {
    await this.fetchProductHtml();
    this.renderContainers();

    document.addEventListener('wishlist:remove', this.removeItem.bind(this));
      // Add event listener for remove buttons
    this.addEventListener('click', this.handleRemoveClick.bind(this));
  }

    handleRemoveClick(event) {
    const removeBtn = event.target.closest('.btn--wishlist-remove');
    if (!removeBtn) return;
    
    event.preventDefault();
    
    const productHandle = removeBtn.getAttribute('data-handle');
    if (productHandle) {
      // Remove from wishlist storage
      Woolman.Wishlist.remove(productHandle);
      
      // Dispatch the wishlist:remove event
      document.dispatchEvent(new CustomEvent('wishlist:remove', {
        detail: productHandle
      }));
    }
  }

  /* This function fetches item HTML snippets and passes them to initContainer function */
  async fetchProductHtml() {
    const promises = [];
    const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    this.wishlist.forEach((productHandle) => {
      promises.push({
        request: fetch(`${rootUrl}products/${productHandle}?view=wishlist`),
        handle: productHandle,
        url: `${rootUrl}products/${productHandle}?view=wishlist`
      });
    });

    const settledPromises = await Promise.allSettled(promises.map(promise => promise.request));

    for (const promise of settledPromises) {
      try {
        const res = await promise.value;
        if (res.status !== 200) { throw res.status }
        const html = await res.text();

        this.productHtml.push(html);
      } catch (err) {
        if (err == 404) {
          const handle = promises.find(promiseItem => promise.value.url.includes(promiseItem.url))?.handle;
          Woolman.Wishlist.remove(handle);
        }

        console.error(err)
      }
    }
  }

  /**
   * Initialize the container with required data
   * @param {HTMLElement} container 
   */
  async renderContainers() {
    if (this.productHtml.length == 0) {
      this.querySelector('[data-empty-wishlist]').removeAttribute('hidden');

      this.containers.forEach(async (container) => {
        if (!container) return;
        container.setAttribute('hidden', true);
      });

      return;
    };

    this.querySelector('[data-empty-wishlist]').setAttribute('hidden', true);

    this.containers.forEach(async (container) => {
      if (!container) return;

      container.innerHTML = '';

      this.productHtml.forEach((html) => {
        container.innerHTML += html;
      });
    });
  }

  removeItem(event) {
    const productHandle = event.detail;

    if (!productHandle || !this.querySelector(`[data-handle="${productHandle}"]`)) return;

    this.querySelector(`[data-handle="${productHandle}"]`).closest('.card').remove();
    this.wishlist = localStorage.getItem(Woolman.Wishlist.settings.storageKey) ? localStorage.getItem(Woolman.Wishlist.settings.storageKey).split(',') : [];

    if (this.wishlist.length == 0) {
      this.querySelector('[data-empty-wishlist]').removeAttribute('hidden');
    };
  }
});
